export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "parsePixelDataToGridNftTransactionData.worker.cd459fc6644e83e41bfb.worker.js");
}
